export default {
  methods: {
    trackEvent(eventName, data = {}) {
      const eventData = this.$trackingUtils.getTrackingData(eventName)
      this.$trackingService.TrackEvent(eventName, { ...eventData, ...data })
    },
    trackPage(pageName, data = {}) {
      const eventData = this.$trackingUtils.getTrackingData(pageName)
      this.$trackingService.TrackPageView(pageName, { ...eventData, ...data })
      this.$abtProvider.logEvent('page_viewed', pageName, {
        ...eventData,
        ...data,
      })
    },
    identifyUser(userId, data = {}) {
      const eventData = this.$trackingUtils.getTrackingData()
      this.$trackingService.IdentifyUser(userId, { ...eventData, ...data })
    },
  },
}
